import React, { useEffect, useMemo, useState } from "react";

function initialsFromName(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[parts.length - 1][0] || ""}`.toUpperCase();
}

/**
 * Ảnh đại diện: hiển thị URL (S3/CDN/Google) hoặc chữ cái khi không có / lỗi tải.
 * @param {string} [cacheBust] — ép trình duyệt tải lại sau khi upload (cùng URL).
 */
export default function UserAvatar({
  url,
  name,
  alt = "",
  cacheBust,
  className = "",
  imgClassName = "",
  roundedClass = "rounded-2xl",
  sizeClass = "h-12 w-12",
  textClass = "text-sm",
}) {
  const [imgOk, setImgOk] = useState(Boolean(url));
  const initials = useMemo(() => initialsFromName(name), [name]);

  useEffect(() => {
    setImgOk(Boolean(url));
  }, [url]);

  const src = useMemo(() => {
    if (!url) return "";
    const bust = cacheBust === undefined || cacheBust === null || cacheBust === "" ? 0 : Number(cacheBust);
    if (!bust) return url;
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}cb=${encodeURIComponent(String(bust))}`;
  }, [url, cacheBust]);

  const hue = name ? (name.charCodeAt(0) * 47 + (name.charCodeAt(1) || 0) * 13) % 360 : 0;

  const fallback = (
    <div
      className={`${sizeClass} ${textClass} flex shrink-0 items-center justify-center font-bold text-white ${roundedClass} ${className}`}
      style={{ background: name ? `hsl(${hue}, 55%, 42%)` : "#94a3b8" }}
      aria-hidden
    >
      {initials}
    </div>
  );

  if (!src || !imgOk) {
    return fallback;
  }

  return (
    <img
      src={src}
      alt={alt || name || "Avatar"}
      className={`${sizeClass} ${roundedClass} shrink-0 object-cover ${imgClassName} ${className}`}
      onError={() => setImgOk(false)}
    />
  );
}
